import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RubricaCreadaType {
	key: string;
	filas: any[];
	puntaje_filas: any[];
}

export interface EditedCellsRubrica {
	[key: string]: string | number | boolean | undefined;
	title: string;
	dataIndex: number;
	key: number;
	editable: boolean;
	keyRegistro: string;
	pickedEdited: boolean;
	isPuntaje?: boolean;
}

const initialState: EditedCellsRubrica[] = [];

const rubricaDataStateSlice = createSlice({
	name: 'rubricaDataState',
	initialState,
	reducers: {
		setDataRubrica: (state, action: PayloadAction<EditedCellsRubrica[]>) => {
			return action.payload;
		},
		addDataRubrica: (state, action: PayloadAction<EditedCellsRubrica>) => {
			return [...state, action.payload];
		},
		updateSpecificFilaRubrica: (
			state,
			action: PayloadAction<{ keyRegistro: string; data: EditedCellsRubrica }>
		) => {
			const newArreglo = state?.map((fila) => {
				if (fila.keyRegistro === action.payload.keyRegistro) {
					return { ...fila, ...action.payload.data };
				}
				return fila;
			});
			return newArreglo;
		},
		updatePickedFilaRubrica: (state, action: PayloadAction<{ keyRegistro: string; pickedEdited: boolean }>) => {
			const newArreglo = state.map((fila) => {
				if (fila.keyRegistro === action.payload.keyRegistro) {
					return { ...fila, pickedEdited: action.payload.pickedEdited };
				}
				return fila;
			});
			return newArreglo;
		},
		removeSpecificFilaRubrica: (state, action: PayloadAction<{ keyRegistro: string }>) => {
			const newArreglo = state.filter((fila) => fila.keyRegistro !== action.payload.keyRegistro);
			return newArreglo;
		},
		resetTodasFilas: (state) => {
			const newArreglo = state.map((fila, index) => ({ ...fila, pickedEdited: false }));
			return newArreglo;
		},
		resetDataRubrica: (state) => {
			return initialState;
		}
	}
});

export const {
	setDataRubrica,
	addDataRubrica,
	updateSpecificFilaRubrica,
	updatePickedFilaRubrica,
	resetDataRubrica,
	resetTodasFilas,
	removeSpecificFilaRubrica
} = rubricaDataStateSlice.actions;

export default rubricaDataStateSlice.reducer;
